import { render } from "./Page404.vue?vue&type=template&id=ebaa1964&scoped=true&ts=true"
import script from "./Page404.vue?vue&type=script&lang=ts"
export * from "./Page404.vue?vue&type=script&lang=ts"

import "./Page404.vue?vue&type=style&index=0&id=ebaa1964&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ebaa1964"]])

export default __exports__